import { Paper, styled } from '@mui/material';

export const ThemeBackgroundImageItemWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	gap: '4px',
	width: '100%',
	textAlign: 'center',
});

export const ThemeBackgroundImageItemLabelWrap = styled(Paper)(() => ({
	borderRadius: '20px',
	padding: '16px',
	width: '100%',

	height: '100px',
}));

export const ThemeBackgroundImageItemLabelInnerWrap = styled(Paper, {
	shouldForwardProp: (prop) => prop !== 'labelBg',
})(({ labelBg }: { labelBg: string }) => ({
	borderRadius: '20px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '100%',
	background: labelBg,
}));
